import { render, staticRenderFns } from "./BoxRoomAvailable.vue?vue&type=template&id=c2ee5358&scoped=true&"
import script from "./BoxRoomAvailable.vue?vue&type=script&lang=ts&"
export * from "./BoxRoomAvailable.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRoomAvailable.vue?vue&type=style&index=0&id=c2ee5358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ee5358",
  null
  
)

export default component.exports